export const GET_ADVERTISER_REQUEST = "GET_ADVERTISER_REQUEST"
export const GET_ADVERTISER_SUCCESS = "GET_ADVERTISER_SUCCESS"
export const GET_ADVERTISER_FAILED = "GET_ADVERTISER_FAILED"

export const GET_S3FILESANDFOLDERS_REQUEST = "GET_S3FILESANDFOLDERS_REQUEST"
export const GET_S3FILESANDFOLDERS_SUCCESS = "GET_S3FILESANDFOLDERS_SUCCESS"
export const GET_S3FILESANDFOLDERS_FAILED  = "GET_S3FILESANDFOLDERS_FAILED"

export const VALIDATE_FOLDER_NAME_REQUEST = "VALIDATE_FOLDER_NAME_REQUEST"
export const VALIDATE_FOLDER_NAME_SUCCESS = "VALIDATE_FOLDER_NAME_SUCCESS"
export const VALIDATE_FOLDER_NAME_FAILED  = "VALIDATE_FOLDER_NAME_FAILED"

export const UPLOAD_FILES_REQUEST = "UPLOAD_FILES_REQUEST"
export const UPLOAD_FILES_SUCCESS = "UPLOAD_FILES_SUCCESS"
export const UPLOAD_FILES_FAILED  = "UPLOAD_FILES_FAILED"

export const UPLOAD_TO_DSP_REQUEST = "UPLOAD_TO_DSP_REQUEST"
export const UPLOAD_TO_DSP_SUCCESS = "UPLOAD_TO_DSP_SUCCESS"
export const UPLOAD_TO_DSP_FAILED  = "UPLOAD_TO_DSP_FAILED"

export const getAdvertiser = ()=>{
    return{type:GET_ADVERTISER_REQUEST}
}

export const getS3FilesAndFoldersAction = (folderName:any)=>{
    return {type:GET_S3FILESANDFOLDERS_REQUEST,payload:folderName}
}

export const validateFolderNameAction = (folderName:string)=>{
    return{type:VALIDATE_FOLDER_NAME_REQUEST,payload:folderName}
}

export const uploadToS3 = (data: any,folder:any)=>{
    return{type:UPLOAD_FILES_REQUEST,payload:{data,folder}}
}

export const uploadToDSP = (files:any[],dsp:string,adv:number /*,env:string*/,os:string,url:string,folder:string,prefix:string,noas:string,cookie:string,useragent:string,timer:string,suffix:string, infinite_fifo:string, infinite_fifo_id: string,ipV6:string)=>{
    return{type:UPLOAD_TO_DSP_REQUEST,payload:{files,dsp,adv/*,env*/,os,url,folder,prefix,noas,timer,cookie,useragent,suffix, infinite_fifo, infinite_fifo_id,ipV6}}
}